import React from "react";

export default function LoadingBox() {
  return (
    <div>
      <span className="loader"></span>
      <span>Loading...</span>
    </div>
  );
}
